import type { ColumnConfig, ConfigTableProps } from '@/components/datatable/dataTableTypes';

export const columns: ColumnConfig[] = [
  { field: 'id', truncateLength: 8, noWrap: true, hideInitial: true },
  { field: 'validFrom', type: 'date' },
  { field: 'validTo', type: 'date' },
  { field: 'name', type: 'string' },
  { field: 'resolvedConditionType' },
  { field: 'conditionTypeId', truncateLength: 8, noWrap: true, hidden: true },
  { field: 'note', truncateLength: 20 },
  { field: 'version', hideInitial: true, align: 'center' },
];

export const tableConfig: ConfigTableProps = {};
